import { render } from "./ListEmpty.vue?vue&type=template&id=5ca61cc9"
import script from "./ListEmpty.vue?vue&type=script&lang=js"
export * from "./ListEmpty.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__